import { getMs } from '@/helpers'
import type { T_UniRes } from '@/types'


export const withTimeout = <T>(promise: Promise<T>, ms: number): Promise<T> => (
  Promise.race([
    promise,
    new Promise<T>(
      (_, reject) => setTimeout(
        () => reject(new Error('timeout')),
        ms,
      )
    ),
  ])
)

export const retry = async <T>(
  fn: () => Promise<T>,
  retries = 3,
  delayMs = getMs('1s'),
): Promise<T> => {
  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      return await fn()
    } catch (err) {
      if (attempt === retries) throw err
      await new Promise((resolve) => setTimeout(resolve, delayMs))
    }
  }

  throw new Error('unreachable')
}

export const checkResponse = <T>(res: T_UniRes<T>) => {
  if (res.code !== 'ok') {
    throw new Error(
      `${res.code}|${res.message || 'Unknown error'}`
    )
  }

  return res
}
